import { render, staticRenderFns } from "./flip-donut-chart.vue?vue&type=template&id=3f2917c6"
import script from "./flip-donut-chart.vue?vue&type=script&lang=js"
export * from "./flip-donut-chart.vue?vue&type=script&lang=js"
import style0 from "./flip-donut-chart.vue?vue&type=style&index=0&id=3f2917c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports